<script>
    export default {
        name: "FaqElement",
        mixins: [],
        data() {
            return {
                givesContextToChildren: true,
                elementType: 'faq',
            }
        },
        computed: {
            getDefaultDataStructure() {
                return {
                    elementId: this.elementId,
                    elementType: this.elementType,
                    responsiveAlignmentClass: {
                        'desktop': '',
                        'tablet-portrait': '',
                        'tablet-landscape': '',
                        'smartphone-portrait': '',
                        'smartphone-landscape': ''
                    },
                    enableCollapse: true,
                    firstExpanded: true,
                }
            },
            enableCollapse() {
                return this.myData.enableCollapse;
            },
            firstExpanded() {
                return this.myData.firstExpanded;
            },
            elementRegistered() {
                // Just a watcher or when MyData becomes available so that we know when to attach event listeners
                // On mount the myData hasn't been populated yet
                return !!this.myData.elementId;
            }
        },
        methods: {
            getEnableCollapse() {
                return this.enableCollapse;
            },
            setEnableCollapse(v) {
                this.changeMyData({enableCollapse: v});
            },
            getFirstExpanded() {
                return this.firstExpanded;
            },
            setFirstExpanded(v) {
                this.changeMyData({firstExpanded: v});
            },
            attachToggleListener() {
                this.myNode.addEventListener('click', this.onClick);
            },
            detachToggleListener() {
                this.myNode.removeEventListener('click', this.onClick);
            },
            onClick(e) {
                if (e.target.closest('.js-faq-toggle')) {
                    const answer = e.target.closest("[data-node-type=\"column\"]").querySelector('.js-faq-answer');
                    const arrow = e.target.closest("[data-node-type=\"column\"]").querySelector('.js-faq-arrow');
                    if (!answer) return;
                    answer.style.display = window.getComputedStyle(answer).display === "block" ? "none" : "block";
                    arrow.classList.toggle("fa-chevron-up");
                    arrow.classList.toggle("fa-chevron-down");
                }
            },
            collapseColumn(column) {
                const answer = column.querySelector('.js-faq-answer');
                const arrow = column.querySelector(".js-faq-arrow");
                if (!answer) return;
                this.applyStyle({styleProp: "display", value: "none", targetSelector: ".js-faq-answer"}, column);
                this.applyClass({newClass: "fa-chevron-down", classesToRemove : "fa-chevron-up", update : true}, arrow);
            },
            expandColumn(column) {
                const answer = column.querySelector('.js-faq-answer');
                const arrow = column.querySelector(".js-faq-arrow");
                if (!answer) return;
                this.applyStyle({styleProp: "display", value: "block", targetSelector: ".js-faq-answer"}, column);
                this.applyClass({newClass: "fa-chevron-up", classesToRemove : "fa-chevron-down", update : true}, arrow);
            },
            collapseAll() {
                [...this.myNode.querySelectorAll('[data-node-type="column"]')].forEach(c => {
                    this.collapseColumn(c);
                })
            },
            expandAll() {
                [...this.myNode.querySelectorAll('[data-node-type="column"]')].forEach(c => {
                    this.expandColumn(c);
                })
            },
            updateExpandiness() {
                [...this.myNode.querySelectorAll(".js-faq-answer")].forEach(n => n.style.removeProperty("display"));

                if (this.enableCollapse) {
                    this.attachToggleListener(); // Duplicate listeners get discarded automatically.
                    this.applyStyle({styleProp: "display", value: "block", targetSelector: ".js-faq-arrow"}, this.myNode);
                    if(this.firstExpanded) {
                        this.expandAll();
                    } else {
                        this.collapseAll();
                    }
                } else {
                    this.applyStyle({styleProp: "display", value: "none", targetSelector: ".js-faq-arrow"}, this.myNode);
                    this.detachToggleListener()
                    this.expandAll();
                }
            },
        },
        watch: {
            enableCollapse: {
                handler(enabled) {
                    if (enabled) {
                        this.attachToggleListener();
                    } else {
                        this.detachToggleListener();
                    }
                }
            }
        },
    }
</script>